import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCategoriesDataView,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";



import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";


const enum fields {

    message = "message",
    
}



interface OwnProps extends WidgetProps {
    fields: {

        [fields.message]: string;
       
    };
    // extendedStyles?: CENBannerStyles;
}

const mapStateToProps = (state: CustomApplicationState) => ({

  
     errorOccured: state.t_components.isErrorOccured.isErrorOccured,
    
});

const mapDispatchToProps = {
    loadCategories,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CENAddressErrorWidgetStyles {
    CENbannerButton?: ButtonPresentationProps;
    CENbannerCenterWrapper?: InjectableCss;
    
}

export const CENAddressErrorWidgetStyles: CENAddressErrorWidgetStyles = {
    
   
};

export const CENAddressError: FC<Props> = ({
    fields,
    errorOccured,
    id
}) => {

    return (
       <StyledWrapper className="CENbannerMainCotainer" >
           {errorOccured ?(
            <Typography>
              {fields.message}
           </Typography>
           ):(
              <Zone zoneName="Content" contentId={id} />
           ) }
        </StyledWrapper>
    );
};

const CENAddressErrorWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CENAddressError),
    definition: {
        group: "Basic",
        icon: "image-landscape",
        fieldDefinitions: [
            
            {
                fieldType: "Translatable",
                name: fields.message,
                editorTemplate: "TextField",
                displayName: "Message",
                defaultValue: "",
            },
           
        ],
    },
};

export default CENAddressErrorWidget;
